module.exports = __webpack_public_path__ + "img/skillsD-3.8be35c85.png";